import { AsyncAPIStudio } from './studio';

import type { FunctionComponent } from 'react';

export const App: FunctionComponent = () => {
  return (
    <AsyncAPIStudio />
  );
};
